module.exports = __webpack_public_path__ + "static/media/logo_new.bbabb8a3.png";